import { IconsDefinition, IconSet } from '../../../icons';
export function createNavItem(icon, name, url) {
    var def = IconsDefinition[icon];
    switch (def.iconSet) {
        case IconSet.ODCode:
            return {
                name: name,
                url: url,
                icon: icon,
                iconStyle: { fontSize: '1rem' },
                iconSpanStyle: { position: 'relative', top: 1, paddingLeft: 2, marginRight: 10 },
            };
        case IconSet.CoreUI:
            return {
                name: name,
                url: url,
                icon: icon,
                iconStyle: { fontSize: '1rem' },
                iconSpanStyle: { position: 'relative', top: 2 },
            };
        case IconSet.Material:
            return {
                name: name,
                url: url,
                icon: icon,
                iconStyle: { fontSize: '1rem' },
                iconSpanStyle: { position: 'relative', top: -1 },
            };
        case IconSet.FontAwesome:
            break;
        case IconSet.SimpleLineIcons:
            break;
        case IconSet.SVGIcon:
            break;
    }
    return { icon: icon, name: name, url: url };
}
//# sourceMappingURL=coreuiUtils.js.map